import { put } from "redux-saga/effects";

import makeRequest from "rdx/utils/makeRequest";
import getErrorActions from "rdx/utils/getErrorActions";
import actions from "rdx/actions";
import messages from "rdx/modules/settings/messages";

function* getSettings() {
  const { success, data, error } = yield* makeRequest.get("/system_settings", {});

  if (success && data) {
    yield put(actions.setAdminSettings(data.body.settings));
  } else if (error) {
    return getErrorActions({
      error,
      message: messages.ERROR_GETTING_SETTINGS_LIST,
    });
  }

  return null;
}

export default getSettings;
